import _each from "lodash/each";
import googleConversion from "web/script/embedded/google-conversion";
import environment from "web/script/modules/environment";

export default {
    // Google Analytics 4 (GA4) conversion actions
    gA4ConversionMeasurementID: "RCC31DCE8N",

    init: function () {
        googleConversion("config", "G-" + this.gA4ConversionMeasurementID, {
            send_page_view: false,
            groups: "GA4",
        });
    },

    send: function (data) {
        // this will contain any promises we generate
        var promises = [];

        _each(data, (event) => {
            // Send Page View events on all pages apart from Lead page
            if (event.data.page_type !== "lead" && event.type === "page_view") {
                const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));
                let gA4Payload = {
                    send_to: "GA4",
                    page_location: window.location.href,
                    page_title: document.title,
                    user_id: environment.get("userId"),
                    content_group: environment.get("pageType"),
                    active_filter: queryParams,
                };
                // Not sending to default group but to GA4 specifically
                googleConversion("event", "page_view", gA4Payload);
            }
        });

        // wait for any promises what we were asked to wait for
        return Promise.all(promises);
    },
};
